__webpack_require__.p = "/static/manage/";